<script>
  import Clickoutside from 'element-ui/lib/utils/clickoutside';

  export default {
    name: "click-outside-wrapper",
    directives: {Clickoutside},
    props: {
      tag: {
        type: String,
        default: "div"
      }
    },
    methods: {
      onClickOutside() {
        this.$emit("outside")
      },
      disableTrigger() {
        this.popperElm = document.body;
      },
      enableTrigger() {
        this.popperElm = null;
      }
    },
    render(h) {
      return h(
        this.tag,
        {
          directives: [
            {
              name: "clickoutside",
              expression: "onClickOutside"
            }
          ],
          on:{
            click:()=>{this.$emit("click")}
          }
        },
        this.$slots.default
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/click-outside-wrapper/click-outside-wrapper.vue